import {Component} from "@angular/core";
import {AlertService, ClientProfileService, UserService} from "../../../_services";
import {MfaService} from "../../../_services/mfa.service";
import {LoginHelper} from "../../../helpers";

@Component({
    standalone: false,
  selector: "mfa-status",
  templateUrl: 'mfa-status.component.html',
  styleUrls: ['./mfa-status.component.scss'],
})
export class MfaStatusComponent {
  currentUser: any;
  disabling = false;
  code: string;
  settings: any;

  constructor(public userService: UserService,
              public mfaService: MfaService,
              public alertService: AlertService,
              public settingsService: ClientProfileService) {
    this.alertService.loading.next(true)
    this.loadUser();
    this.settingsService.getSettings(LoginHelper.getTenantName()).subscribe(r => this.settings = r);
  }

  loadUser() {
    this.userService.getCurrent().subscribe(u => {
      this.currentUser = u;
      this.alertService.loading.next(false);
    })
  }

  initDisable() {
    this.mfaService.initDisable().subscribe();
    this.disabling = true;
  }

  disable() {
    this.alertService.loading.next(true)
    this.mfaService.completeDisable(this.code).subscribe(s => {
      this.disabling = false;
      this.loadUser();
    }, e => {
      this.alertService.loading.next(false);
      this.alertService.error(e.error.exceptionMessage);
    })
  }
}
